<template>
  <div v-if="showControls" :class="container">
    <base-button
      v-if="!hideLeft"
      :aria-label="$t.previousSlide"
      :class="[control, carouselRef?.carousel.canScrollPrev ? classes.enabled : classes.disabled]"
      :disabled="!carouselRef?.carousel.canScrollPrev"
      @click="carouselRef?.scrollPrev()"
    >
      <vf-icon dir="left" name="chevron" size="md" />
    </base-button>
    <base-button
      v-if="!hideRight"
      :aria-label="$t.nextSlide"
      :class="[control, carouselRef?.carousel.canScrollNext ? classes.enabled : classes.disabled]"
      :disabled="!carouselRef?.carousel.canScrollNext"
      @click="carouselRef?.scrollNext()"
    >
      <vf-icon dir="right" name="chevron" size="md" />
    </base-button>
  </div>
</template>

<script setup lang="ts">
import type { Responsive } from '#types/common'
import type { CarouselElevateInstance } from '#types/components/vf/carousel-elevate'
import type { ColorSchema } from '#types/design-system'

const { carouselRef, variant, hideLeft, hideRight } = defineProps<{
  carouselRef: CarouselElevateInstance | null | undefined
  variant?: ColorSchema | Responsive<ColorSchema>
  hideLeft?: boolean
  hideRight?: boolean
}>()

const {
  alwaysShow,
  brandClasses: { container, control, disabled, enabled }
} = useAppConfig().components.vf.carouselControls

const classes = computed(() => {
  const normalizedVariant = normalizeResponsive(variant)
  return Object.entries(normalizedVariant).reduce(
    (acc, [k, v]) => ({
      enabled: `${acc.enabled} ${enabled[k][v ?? 'light']}`.trim(),
      disabled: `${acc.disabled} ${disabled[k][v ?? 'light']}`.trim()
    }),
    { enabled: '', disabled: '' }
  )
})

const showControls = computed(() => carouselRef?.carousel && (alwaysShow || carouselRef.canScroll))
</script>
